import * as React from 'react';

import { DrawerProps } from './drawerprops';
import Drawer from "antd/lib/drawer";


/**
 * This function returns all the drawer components
 * @param props has all input parameters to load the Card
 * @returns JSX code for Drawer  Components
 */
export const DrawerComp = (
  props: DrawerProps
) => {
  const {
    title,
    placement = "right",
    width = "256px",
    closable = false,
    className="quick-menu",
    visible,
    children,
    onClose
  } = props;

  return (
    <>
      <Drawer
        title={title}
        placement={placement}
        width = {width}
        closable={closable}
        visible={visible}
        mask={true}
        className={className}
        onClose = {onClose}
      >
        {children}
      </Drawer>
    </>
  );
};